import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledGrantPage from 'components/pages/Auth/GrantPage/GrantPage.styles';
import GrantForm from 'components/organisms/Forms/GrantForm/GrantForm';

const GrantPage = (props) => {
  const innerProps = useComponentProps(props, 'GrantPage');

  return <StyledGrantPage {...innerProps}>
    <GrantForm className="GrantPage-form"/>
  </StyledGrantPage>
};

GrantPage.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default GrantPage;
